$(document).ready(function () {
    if ( $('.animate-text').length ) {
      $('.animate-text span:not(.hero-letter-arrow)').each( function (i, span) {
        setTimeout( function () {
          $(span).addClass('active')
        }, 300 * i )
      })
    }

    if ( $('.module__content-viz').length ) {
      $('.module__content-viz .sub-nav__link').on('click', function (e) {
        e.preventDefault();
        const handle = $(this).attr('href')
        selectContentVizSection(handle)
      })
    }

})

if (window.Shopify && Shopify.designMode) {
  const animatedTextTimers = new WeakMap()

  function replayAnimatedText (root) {
    const headings = root.querySelectorAll('.animate-text')

    headings.forEach(function (heading) {
      const spans = heading.querySelectorAll('span:not(.hero-letter-arrow)')
      if (!spans.length) return

      const previousTimers = animatedTextTimers.get(heading) || []
      previousTimers.forEach(clearTimeout)

      spans.forEach(function (span) {
        span.classList.remove('active')
      })

      // Commit the reset state before re-adding active so CSS transitions replay.
      void heading.offsetWidth

      const timers = []
      spans.forEach(function (span, index) {
        timers.push(setTimeout(function () {
          span.classList.add('active')
        }, 100 + (300 * index)))
      })
      animatedTextTimers.set(heading, timers)
    })
  }

  document.addEventListener('shopify:section:load', function (event) {
    replayAnimatedText(event.target)
  })
}

function selectContentVizSection (handle) {  
  if ( !$(`#content-viz-link-${handle}`).closest('.sub-nav-item').hasClass('sub-nav-item--active') ) {
    $('.sub-nav-item--active').removeClass('sub-nav-item--active')
    $(`#content-viz-link-${handle}`).closest('.sub-nav-item').addClass('sub-nav-item--active')
    $('.content-viz__slide.active').removeClass('active')
    $(`#content-viz-${handle}`).addClass('active')
    $('#blog-categories').val(handle)
  }
}

// Bounded, decorative leaf physics. Canvas never captures clicks or touch input.
;(function () {
  const instances = new Map()
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)')
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)')

  function create(canvas) {
    if (instances.has(canvas)) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    const baseCanvas = document.createElement('canvas')
    const baseCtx = baseCanvas.getContext('2d')
    if (!baseCtx) return
    const block = canvas.closest('.hero-has-seasonal-background')
    if (!block) return
    const leaves = []
    const colors = ['#aa6337', '#c38a43', '#987137', '#b57447', '#ce9a54']
    const frequency = Math.max(4, Math.min(32, Number(canvas.dataset.frequency) || 16))
    const size = Math.max(0.5, Math.min(2, (Number(canvas.dataset.size) || 100) / 100))
    const speed = Math.max(0.5, Math.min(2, (Number(canvas.dataset.speed) || 100) / 100))
    // Keep one bounded pool: larger piles at rest, with no allocations while scattering.
    const cap = Math.min(288, Math.max(180, frequency * 9))
    // Extra transparent height lets forcefully scattered leaves travel above the piles.
    const canvasHeight = 420
    const baseline = canvasHeight - 2
    const gaps = []
    let width = 1, pixelRatio = 1, frame = 0, last = 0, elapsed = 0, visible = false, pointer = null

    function pileHeight(x) {
      const u = x / width
      let mound = 0
      ;[0.17, 0.51, 0.84].forEach(function (center) {
        mound = Math.max(mound, 72 * Math.exp(-Math.pow((u - center) / 0.105, 2)))
      })
      return mound
    }
    function settledY(leaf) {
      return baseline - pileHeight(leaf.x) * leaf.depth
    }
    function add(settled) {
      const center = [0.17, 0.51, 0.84][Math.floor(Math.random() * 3)]
      // Two random samples create a center-weighted spread instead of a flat row.
      const offset = ((Math.random() + Math.random()) - 1) * 0.125
      const x = Math.max(8, Math.min(width - 8, width * (center + offset)))
      // Bias settled leaves toward the baseline so each mound looks packed.
      const depth = 0.02 + Math.pow(Math.random(), 1.25) * 0.98
      const leaf = { x: x, y: -10, depth: depth,
        vx: 0, vy: settled ? 0 : 16, angle: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 3, radius: (4 + Math.random() * 3) * size,
        color: colors[Math.floor(Math.random() * colors.length)], moving: !settled }
      if (settled) leaf.y = settledY(leaf) - Math.random() * 3
      leaves.push(leaf)
    }
    function paintLeaf(context, leaf, alpha) {
      context.save()
      context.translate(leaf.x, leaf.y)
      context.rotate(leaf.angle)
      context.globalAlpha = alpha
      context.fillStyle = leaf.color
      context.beginPath()
      context.moveTo(-leaf.radius, 0)
      context.quadraticCurveTo(0, -leaf.radius, leaf.radius, 0)
      context.quadraticCurveTo(0, leaf.radius, -leaf.radius, 0)
      context.fill()
      context.strokeStyle = 'rgba(90, 60, 30, 0.35)'
      context.lineWidth = 0.6
      context.beginPath()
      context.moveTo(-leaf.radius, 0)
      context.lineTo(leaf.radius, 0)
      context.stroke()
      context.restore()
    }
    function buildBasePile() {
      baseCanvas.width = Math.round(width * pixelRatio)
      baseCanvas.height = Math.round(canvasHeight * pixelRatio)
      baseCtx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
      baseCtx.clearRect(0, 0, width, canvasHeight)
      const spacing = Math.max(3.5, 5.2 * size)

      // This dense under-layer is rasterized once per resize, then reused every frame.
      for (let x = spacing / 2; x < width; x += spacing) {
        const height = pileHeight(x)
        if (height < spacing) continue
        for (let y = baseline - height + spacing / 2; y < baseline + spacing; y += spacing) {
          paintLeaf(baseCtx, {
            x: x + (Math.random() - 0.5) * spacing * 0.8,
            y: y + (Math.random() - 0.5) * spacing * 0.8,
            angle: Math.random() * Math.PI,
            radius: (3.8 + Math.random() * 1.8) * size,
            color: colors[Math.floor(Math.random() * colors.length)]
          }, 0.9)
        }
      }
    }
    function disturbPile(x, count) {
      const widthBoost = Math.min(34, count * 1.4)
      let gap = gaps.find(function (item) { return Math.abs(item.x - x) < (item.width + 46) / 2 })
      if (gap) {
        gap.x = (gap.x * 2 + x) / 3
        gap.width = Math.min(110, Math.max(gap.width, 48 + widthBoost))
        gap.depth = Math.min(42, gap.depth + Math.min(10, count * 0.45))
        gap.hold = 0.75
      } else {
        gap = { x: x, width: 48 + widthBoost, depth: 18 + Math.min(18, count * 0.7), strength: 0, hold: 0.75 }
        gaps.push(gap)
        if (gaps.length > 18) gaps.shift()
      }
    }
    function draw() {
      ctx.clearRect(0, 0, width, canvasHeight)
      ctx.drawImage(baseCanvas, 0, 0, baseCanvas.width, baseCanvas.height, 0, 0, width, canvasHeight)

      // Cut open-topped divots rather than isolated holes, so disturbed areas read as
      // missing leaves along the mound's surface instead of transparent ovals.
      ctx.save()
      ctx.globalCompositeOperation = 'destination-out'
      gaps.forEach(function (gap) {
        const half = gap.width / 2
        const surface = baseline - pileHeight(gap.x)
        const depth = gap.depth * gap.strength
        ctx.globalAlpha = 0.82 * gap.strength
        ctx.beginPath()
        ctx.moveTo(gap.x - half, 0)
        ctx.lineTo(gap.x + half, 0)
        ctx.lineTo(gap.x + half, surface + depth * 0.12)
        ctx.bezierCurveTo(gap.x + half * 0.65, surface + depth * 0.35, gap.x + half * 0.42, surface + depth, gap.x, surface + depth)
        ctx.bezierCurveTo(gap.x - half * 0.42, surface + depth, gap.x - half * 0.65, surface + depth * 0.35, gap.x - half, surface + depth * 0.12)
        ctx.closePath()
        ctx.fill()
      })
      ctx.restore()

      leaves.forEach(function (leaf) {
        paintLeaf(ctx, leaf, 0.82)
      })
    }
    function tick(now) {
      frame = 0
      if (!visible || document.hidden || reduced.matches) return
      if (last && now - last < 33) { frame = requestAnimationFrame(tick); return }
      const dt = last ? Math.min((now - last) / 1000, 0.05) : 0.033
      last = now
      elapsed += dt
      gaps.forEach(function (gap) {
        if (gap.hold > 0) {
          gap.hold -= dt
          gap.strength = Math.min(1, gap.strength + dt * 7)
        } else {
          gap.strength = Math.max(0, gap.strength - dt * 1.8)
        }
      })
      for (let i = gaps.length - 1; i >= 0; i--) {
        if (gaps[i].strength === 0 && gaps[i].hold <= 0) gaps.splice(i, 1)
      }
      if (leaves.length < cap && elapsed > 16 / frequency / speed) {
        add(false)
        elapsed = 0
      }
      leaves.forEach(function (leaf) {
        if (!leaf.moving) return
        leaf.vy += 280 * dt
        leaf.vx *= Math.exp(-0.9 * dt)
        leaf.x = Math.max(5, Math.min(width - 5, leaf.x + leaf.vx * dt))
        leaf.y += leaf.vy * dt
        leaf.angle += leaf.spin * dt
        if (leaf.y >= settledY(leaf) && leaf.vy > 0) {
          leaf.y = settledY(leaf) - Math.random() * 3
          leaf.moving = false
        }
      })
      draw()
      if (leaves.length < cap || gaps.length || leaves.some(function (leaf) { return leaf.moving })) frame = requestAnimationFrame(tick)
    }
    function wake() {
      if (!frame && visible && !document.hidden && !reduced.matches) {
        last = 0
        frame = requestAnimationFrame(tick)
      }
    }
    function resize() {
      const oldWidth = width
      width = Math.max(1, canvas.getBoundingClientRect().width)
      pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5)
      canvas.width = Math.round(width * pixelRatio)
      canvas.height = Math.round(canvasHeight * pixelRatio)
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
      buildBasePile()
      leaves.forEach(function (leaf) {
        leaf.x *= width / oldWidth
        if (!leaf.moving) leaf.y = settledY(leaf)
      })
      gaps.forEach(function (gap) { gap.x *= width / oldWidth })
      draw()
      wake()
    }
    function move(event) {
      if (!finePointer.matches || reduced.matches || !visible || event.pointerType === 'touch') return
      const rect = canvas.getBoundingClientRect()
      const x = event.clientX - rect.left, y = event.clientY - rect.top
      const previous = pointer
      const delta = previous ? Math.max(-32, Math.min(32, x - previous.x)) : 0
      pointer = { x: x, y: y }
      if (y < baseline - 110 || y > canvasHeight + 10) return
      let hit = false
      let hitCount = 0
      let hitX = 0
      leaves.forEach(function (leaf) {
        if (leaf.moving) return
        // Test the whole path between pointer events so a quick swipe cannot skip leaves.
        const ax = previous ? previous.x : x
        const ay = previous ? previous.y : y
        const dx = x - ax
        const dy = y - ay
        const lengthSquared = dx * dx + dy * dy
        const t = lengthSquared ? Math.max(0, Math.min(1, ((leaf.x - ax) * dx + (leaf.y - ay) * dy) / lengthSquared)) : 0
        const distance = Math.hypot(leaf.x - (ax + dx * t), leaf.y - (ay + dy * t))
        if (distance > 52) return
        leaf.moving = true
        hitCount++
        hitX += leaf.x
        const direction = delta === 0 ? (Math.random() < 0.5 ? -1 : 1) : Math.sign(delta)
        leaf.vx = delta * 11 + direction * (55 + Math.random() * 105)
        leaf.vy = -190 - Math.random() * 125 - Math.abs(delta) * 2.5
        leaf.spin = (Math.random() - 0.5) * 12
        hit = true
      })
      if (hit) {
        disturbPile(hitX / hitCount, hitCount)
        wake()
      }
    }
    function tap(event) {
      if (event.pointerType === 'mouse' || reduced.matches || !visible) return
      const rect = canvas.getBoundingClientRect()
      const x = event.clientX - rect.left
      const y = event.clientY - rect.top
      if (y < baseline - 125 || y > canvasHeight + 10) return
      let hitCount = 0
      let hitX = 0

      leaves.forEach(function (leaf) {
        if (leaf.moving || Math.hypot(leaf.x - x, leaf.y - y) > 74) return
        const offset = leaf.x - x
        const direction = Math.abs(offset) < 3 ? (Math.random() < 0.5 ? -1 : 1) : Math.sign(offset)
        leaf.moving = true
        leaf.vx = direction * (115 + Math.random() * 175) + offset * 2.2
        leaf.vy = -210 - Math.random() * 145
        leaf.spin = (Math.random() - 0.5) * 12
        hitCount++
        hitX += leaf.x
      })

      if (hitCount) {
        disturbPile(hitX / hitCount, hitCount)
        wake()
      }
    }
    function leave() { pointer = null }
    function visibility() { if (document.hidden) { cancelAnimationFrame(frame); frame = 0 } else wake() }
    function motion() {
      cancelAnimationFrame(frame); frame = 0
      gaps.length = 0
      leaves.forEach(function (leaf) { leaf.moving = false; leaf.y = settledY(leaf) })
      draw(); wake()
    }
    const observer = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting
      if (visible) wake()
      else { cancelAnimationFrame(frame); frame = 0; pointer = null }
    }, { threshold: 0.1 })
    const resizer = new ResizeObserver(resize)
    resize()
    for (let i = 0; i < Math.ceil(cap * 0.98); i++) add(true)
    draw()
    observer.observe(canvas)
    resizer.observe(canvas)
    block.addEventListener('pointermove', move, { passive: true })
    block.addEventListener('pointerdown', tap, { passive: true })
    block.addEventListener('pointerleave', leave)
    document.addEventListener('visibilitychange', visibility)
    reduced.addEventListener('change', motion)
    instances.set(canvas, function () {
      cancelAnimationFrame(frame)
      observer.disconnect(); resizer.disconnect()
      block.removeEventListener('pointermove', move)
      block.removeEventListener('pointerdown', tap)
      block.removeEventListener('pointerleave', leave)
      document.removeEventListener('visibilitychange', visibility)
      reduced.removeEventListener('change', motion)
    })
  }
  function init() {
    instances.forEach(function (destroy, canvas) {
      if (!canvas.isConnected) { destroy(); instances.delete(canvas) }
    })
    document.querySelectorAll('[data-leaf-piles]').forEach(create)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
  else init()
  document.addEventListener('hero:loop-slides-updated', init)
  document.addEventListener('shopify:section:load', init)
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, canvas) {
      if (event.target.contains(canvas)) { destroy(); instances.delete(canvas) }
    })
  })
})()
